/**
 * ⭐ board 2814 M6 fix round 1 (ux F6) - THE ONE CEILING ON A PRICE, IN CENTS, in a
 * module the browser bundle may import (the server's own copy sits in
 * `core/data/account-prices-repo.ts`, which the client cannot reach).
 *
 * ⛔ ONE LITERAL. `MAX_ACCOUNT_PRICE_CENTS` (the account price book's sink) is this
 * value, and `server/app.ts`'s `MAX_MONEY_CENTS` (what `parseMoneyCents` refuses
 * past) is that one, so the client's pre-check on "Change the price" and the
 * server's 400 cannot disagree. Raise it HERE, and say so on the board.
 */
export const MAX_PRICE_CENTS = 10_000_000;
